import React, {useState} from 'react'
import {Flex} from "reflexbox";
import {
  Chat,
  Gavel,
  Menu,
  AssignmentTurnedIn,
  Map,
  AttachMoney,
  ExitToApp,
  School,
  ThumbsUpDown
} from "@mui/icons-material";
import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom"
import * as route from "../helpers/routes";
import Chip from "@mui/material/Chip";
import {useSelector, useDispatch} from "react-redux";
import { updateTour } from "../../redux/uiSlice";
import {ToMap} from "../helpers/routes";
import {courseHasMap} from "../courseContent/courseObjects";
import PersonalProfileDisplayAndEdit from "../PersonalProfileDisplayAndEdit";
import TeamMemberNamesList from "../gameSetupAndLobby/TeamMemberNamesList";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TeamNameDisplayAndEdit from "../gameSetupAndLobby/TeamNameDisplayAndEdit";


const HamburgerMenu = (props) => {
  let navigate = useNavigate();
  const platform = useSelector((state) => state.platform);
  const { uid } = useSelector((state) => state.user);
  const { teamDetails } = useSelector((state) => state.team);
  const { teammateInfo } = teamDetails || {};

  const [editNameDialog, setEditNameDialog] = useState(false);
  const [drawer, toggleDrawer] = useState(false);
  const dispatch = useDispatch();

  const showCourseMap = courseHasMap(props?.currentCourse);

  const menu = {
    getSomewhere: {
      name: 'Get somewhere',
      newSection: true,
    },
    ...(showCourseMap && {
      nationalMallMap: {
        name: 'Map',
        icon: <Map/>,
        link: ToMap(props?.currentCourse || null),
      },
    }),
    courseSelection: {
      name: 'Start Menu',
      icon: <ExitToApp/>,
      link: route.HOME,
    },
    getHelp: {
      name: 'Game questions?',
      newSection: true,
    },
    whatToExpect: {
      name: 'What to Expect',
      icon: <AssignmentTurnedIn/>,
      link: route.WHAT_TO_EXPECT,
    },
    rules: {
      name: 'Rules',
      icon: <Gavel/>,
      link: route.RULES,
    },
    helpUs: {
      name: 'Help us out',
      newSection: true,
    },
    feedback: {
      name: 'Share feedback',
      icon: <Chat/>,
      link: route.FEEDBACK,
    },
    rateUS: {
      name: 'Review us',
      icon: <ThumbsUpDown/>,
      link: route.RATEUS,
    },
    tip: {
      name: 'Support us',
      icon: <AttachMoney/>,
      link: route.TIP,
    },

  };

  const goToLink = (targetURL) => {
    navigate(targetURL);
  };

  const SectionHeader = (props) => (
    <Typography style={{padding: '16px 16px 0 16px'}} variant={'h6'} color={'primary'}>{props.children}</Typography>
  );

  const menuItems = [];
  for (const [key, value] of Object.entries(menu)) {
    let pushItem = <ListItem button key={key} style={{paddingTop: '10px', paddingBottom: '10px'}}
                             onClick={value.link ? () => goToLink(value.link) : value.func}>
      <ListItemIcon>{value.icon}</ListItemIcon>
      <ListItemText>{value.name}</ListItemText>
    </ListItem>;
    if (value.newSection) {
      pushItem = <div key={key}><SectionHeader> {value.name} </SectionHeader></div>
    }
    menuItems.push(pushItem)
  }
  return (<>
    {props.chip ? <Chip style={{display: 'flex', alignItems: 'center', paddingTop: '5px'}}
                        label={<Menu/>} color={'primary'}
                        onClick={() => toggleDrawer(!drawer)}/>
      : <Menu color={'primary'} onClick={() => toggleDrawer(!drawer)}/>
    }
    <PersonalProfileDisplayAndEdit open={editNameDialog} close={() => setEditNameDialog(false)}/>
    <Drawer open={drawer} onClose={() => toggleDrawer(!drawer)}>
      <Flex style={{flexDirection: 'column', width: '240px', paddingTop: platform.statusBarHeight}}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon/>} aria-controls="team-content" id="team-header"
                            style={{paddingLeft: 0}}>
            <SectionHeader>Your Team</SectionHeader>
          </AccordionSummary>
          <div style={{paddingLeft: '16px', paddingBottom: '16px', overflowX: 'auto'}}>
            <TeamNameDisplayAndEdit/>
            <Typography style={{fontWeight: 'bold', paddingTop: '16px'}}>Members </Typography>
            {teammateInfo && (
              <TeamMemberNamesList
                editName={() => setEditNameDialog(true)}
                uid={uid}
                teammateInfo={teammateInfo}/>
            )}
          </div>
        </Accordion>
        {/*<hr />*/}
        <List>{menuItems}</List>
      </Flex>
    </Drawer>
  </>)
};

export default HamburgerMenu;